import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'

export const instance = new CachedRequest(1000 * 15)

export async function apiGetLang(lang: string) {
  return instance.get(`${endpoint.getLang}/${lang}`, lang)
}